<template>
  <div class='btn_nav'>
        <div class='contain'>
            <slot></slot>
        </div>
    </div>
</template>

<script>


export default {
  name: "BtnNav",
  components: {},
  data() {
    return {

    }
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style lang="scss">
  .btn_nav {
    position: fixed;
    z-index: 5;
    top: 87px;
    width: 100%;
    background: white;
    box-shadow: 0 0 8px hsla(0,0%,50.2%,.35);

    .contain {
        padding: 10px 50px;
        display: flex;
        justify-content: flex-end;

        @media screen and (max-width: 700px) {
            padding: 0 30px;
        }
    }

    .btn {
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>
